
import { requireJson, getdict } from '@/commons/util.js'
/* GET_dictJson:'/dqi-hymanage/dict/json/all',//字典
GET_vehicleBrand:'/dqi-hymanage/dict/vehicleBrand',//获取车辆品牌
GET_vehicleModel:'/dqi-hymanage/dict/vehicleModel/{vehicleBrand}',//根据车辆品牌获取车辆型号
GET_vehicleStyles:'/dqi-hymanage/dict/vehicleStyles/{vehicleBrand}/{vehicleModel}',//根据车辆品牌获取车辆型号
GET_tollgate:'/dqi-hymanage/tollgate/all',//所有卡口id、名称
*/
async function getSelectoptions(ary) {
  //console.log('aaaaaa',ary)
  /* let jsondata = await getdict('/dqi-hymanage/dict/json/all')
   console.log('json字典', jsondata);
 */
  let obj = {};
  for (let item of ary) {
    if ('select' in item && !item.hasOwnProperty('api')) {

      obj[item.select] = requireJson(item.select)
      //  console.log('bbbbb',obj[item.select],item)
      if (!obj[item.select] || obj[item.select]=="") {
        let jsonStr = null
        try {
          jsonStr = require(`../../../static/json/dictionary/${item.select}.json`);
        } catch (error) {
          jsonStr = ""
        }
        //  console.log('aaaa',jsonStr,item.select)
        obj[item.select] = jsonStr;
      }
    } else if (item.api) {
      switch (item.api) {
        case "/dqi-hymanage/dict/vehicleBrand":
          let vehicleBrand = await getdict(item.api)
          console.log('车辆品牌', vehicleBrand)
          obj[item.select] = vehicleBrand;
          break;
        case "/dqi-hymanage/tollgate/all":
          let tollgateID = await getdict(item.api);
          console.log('卡口数据', tollgateID)
          let arr = [];
          for (let i = 0; i < tollgateID.length; i++) {
            let obj1 = { name: tollgateID[i].name, code: tollgateID[i].id };
            arr.push(obj1)
          }
          obj[item.select] = arr;
          sessionStorage[item.select] = JSON.stringify(arr);
          break;

        case "/dqi-hymanage/tollgate/page":
          let tollgate = await getdict(item.api, 'Post', {
            "pageRow": 500,
            "pageIndex": 1,
            "type": item.tollgatetype
          });
          console.log('卡口数据', tollgate)
          let arrs = [];
          for (let i = 0; i < tollgate.length; i++) {
            let obj1 = { name: tollgate[i].name, code: tollgate[i].tid };
            arrs.push(obj1)
          }
          obj[item.select] = arrs;
          sessionStorage[item.select] = JSON.stringify(arrs);
          break;

        case "/dqi-hymanage/device/page":
          let deviceID = await getdict(item.api, 'Post', {
            "pageRow": 500,
            "pageIndex": 1,
            "deviceType": 3
          });
          //console.log('设备数据', deviceID);
          let arr1 = [];
          for (let i = 0; i < deviceID.length; i++) {
            let obj1 = { name: deviceID[i].deviceName, code: deviceID[i].deviceID };
            arr1.push(obj1)
          }
          obj[item.select] = arr1;
          sessionStorage[item.select] = JSON.stringify(arr1);
          break;
        
        case "getCoId":
            let CoIds = JSON.parse(localStorage.getItem('company'));
            console.log(CoIds);
            obj[item.select] = CoIds;
            break;
        default:
          break;
      }
    }

  }
  //console.log('cccccc',obj)
  return obj
}


const formlistShow = [
  "plateNo",//车牌
  "plateColor",//车牌颜色
  "personStatus",//人员状态
  "personType",//人员类型
  "passType",//人员通行类型
  "plateClass",//车牌类型
  "rfidPlateNumber",//电子车牌
  "cartime",//过车时间
  "passingTime", //抓拍通行时间
  "vehicleClass",//车辆类型
  "vehicleType",//车辆类别
  "vehicleBrand1",//车辆品牌分组
  "vehicleBrand",//车辆品牌
  "vehicleColor",//车身颜色
  "title",//布控标题
  "dispositionID",//布控编号
  "dispositionType",//布控类型
  "dispositionStatus",//布控状态
  /* "adminDivision",//行政区域
  "trafficType",//设备类型 */
  "coId",//企业id
  "coName",//企业名称
  "coBusiness",//经营范围
  "coType",//企业类型
  "personName",//姓名
  "personCompany",//申请企业
  "coEin",//企业税号
  // "selection",//设备选择id
  /* "cardreadType",//读卡器类型
  "warnlibrary",//告警库来源 */
  "checkStatus",//批审状态
  "personIdcard",//身份证号
  "personSex",//性别
  "timeType",//时间类型
  "timeType2",//时间类型
  "deviceID", //设备选择id
  "deviceName",//设备名称
  "deviceType",//设备类型
  // "carType",//来访车辆类型
  "carFrom",//来访车辆类型
  "passTime",//通行时间
  "deviceStatus",//设备状态
  "frontRear",//车头车尾
  "inOutFlag",//出入口标识
  "source",//申报来源
  "yesOrNo",//是否
  "tollgateID",//卡口
  "persontollgate",//人脸卡口
  "cartollgate",//车辆卡口
  "cameratollgate",//抓拍相机卡口
  "tollgateType",//卡口类型
  "tollgateStatus",//卡口状态
  "tollgateName",//卡口名称
  "filename",//资料名称
  "issuetime",//发布时间
  "safetyTitle",//安全教育标题
  "moduleCode",//安全教育分类"
  "passTime",//通过时间
  "coStatus",//企业状态
  "tableName",//操作日志表
  "logTime",//操作日志查询时间
  "creator"//操作人
];

/* type 1 车牌省缀加号码表单
   type 2 单选类型表单
   type 3 时间区间表单
   type 4 分组单选表单
   type 5 多选表单
   type 6 输入表单
   type 7 设备选择 功能
   type 8 时间类型表单
   type 9 时间范围 ,时分秒
*/

//表单初始化
export const getformfield = function () {
  return {
    carprefix: "", //车牌前缀省标识
    plateNo: "", //车牌后几位
    rfid_carprefix: "", //电子车牌前缀省标识
    rfidPlateNumber: "", //电子车牌后几位
    plateColor: "", //车牌颜色
    personStatus: "", //人员状态
    personType: "",//人员类型
    passType: "",//人员通行类型
    plateClass: "", //车牌类型
    cartime: "", //过车时间
    passingTime: "", //抓拍通行时间
    vehicleClass: "", //车辆类型
    vehicleType: "",//车辆类别
    vehicleBrand: "", //车辆品牌分组
    vehicleBrandType: "",//车辆品牌
    vehicleBrandModel: "",//车辆品牌下的型号
    vehicleBrandStyles: "",//车辆品牌下的年代款
    vehicleColor: "", //车身颜色
    title: "",//布控标题
    dispositionID: "", //布控编号
    dispositionType: "", //布控类型
    dispositionStatus: "", //布控状态
    /* adminDivision: "", //行政区域 */
    /* trafficType: [], //设备类型多选 */
    coId: "",//企业id
    coName: "", //企业名称
    coBusiness: "",//经营范围
    coType: "",//企业类型
    deployTitle: "", //布控标题
    personName: "", //姓名
    personCompany: "", //申请名称
    coEin: "", //企业税号
    deviceID: "", //设备选择id
    /* cardreadType: "", //读卡器类型
    warnlibrary: "", //告警库来源 */
    checkStatus: "", //批审状态
    personIdcard: "", //身份证号
    personSex: "", //性别
    timeType: "0",//时间类型
    timeType2: "0",//时间类型
    deviceName: "",//设备名称
    deviceType: "",//卡口、设备类型
    // carType: "",//来访车辆类型
    carFrom: "",//来访车辆类型
    passTime: "",//通行时间
    deviceStatus: "",//设备状态
    fromCar: "",//方向
    frontRear: "",//车头车尾
    inOutFlag: "",//出入口标识
    source: "",//申报来源
    yesOrNo: "",//是否
    tollgateID: "",//卡口
    persontollgate: "",//人脸卡口
    cartollgate: "",//车辆卡口
    cameratollgate: "",//抓拍相机卡口
    tollgateType: "",//卡口类型
    tollgateStatus: "",//卡口状态
    filename: "",//资料名称
    issuetime: "",//发布时间
    safetyTitle: "",//安全教育标题
    moduleCode: "",//安全教育分类
    passTime: "",//通过时间
    coStatus: "",//企业状态
    tableName: "",//操作日志表
    logTime: "",//操作日志查询时间
    creator: ""//操作人
  }
}


//表单类型配置
export const allFormList = {
  plateNo: {
    label: "车牌号码:",
    type: 1,
    formV1: "carprefix",
    formV2: "plateNo",
    select: "platePrefix"
  },
  rfidPlateNumber: {
    label: "电子车牌号码:",
    type: 1,
    formV1: "rfid_carprefix",
    formV2: "rfidPlateNumber",
    select: "platePrefix"
  },
  plateClass: {
    label: "车牌类型:",
    type: 2,
    formV: "plateClass",
    select: "plateClass",
    width: "130px"
  },
  personStatus: {
    label: "人员状态:",
    type: 2,
    formV: "personStatus",
    select: "personStatus",
    width: "80px"
  },
  personType: {
    label: "人员类型:",
    type: 2,
    formV: "personType",
    select: "personType",
    width: "140px"
  },
  passType: {
    label: "人员通行类型:",
    type: 2,
    formV: "passType",
    select: "PERSONPASSTYPE",
    width: "160px"
  },
  plateColor: {
    label: "车牌颜色:",
    type: 2,
    formV: "plateColor",
    select: "plateColor",
    width: "100px"
  },
  cartime: {
    label: "过车时间:",
    type: 3,
    formV: "cartime"
  },
  passingTime: {
    label: "抓拍通行时间:",
    type: 3,
    formV: "passingTime"
  },
  vehicleClass: {
    label: "车辆类型:",
    type: 2,
    formV: "vehicleClass",
    select: "vehicleClass",
    width: "100px"
  },
  vehicleType: {
    label: "车型类别:",
    type: 2,
    formV: "vehicleType",
    select: "vehicleType",
    width: "120px"
  },
  vehicleBrand1: {
    label: "车辆品牌分组:",
    type: 4,
    api: '/dqi-hymanage/dict/vehicleBrand',
    formV: "vehicleBrand1",
    select: "vehicleBrand",
    width: "120px"
  },
  vehicleBrand: {
    label: "车辆品牌:",
    type: 2,
    formV: "vehicleBrand",
    select: "VehicleBrand",
    width: "60px"
  },
  vehicleColor: {
    label: "车身颜色:",
    type: 2,
    formV: "vehicleColor",
    select: "vehicleColor",
    width: "60px"
  },
  title: {
    label: "布控标题:",
    type: 6,
    formV: "title",
    width: "120px"
  },
  dispositionID: {
    label: "布控编号:",
    type: 6,
    formV: "dispositionID",
    width: "120px"
  },
  dispositionType: {
    label: "布控类型:",
    type: 2,
    formV: "dispositionType",
    select: "dispositionType",
    width: "140px"
  },
  dispositionStatus: {
    label: "布控状态:",
    type: 2,
    formV: "dispositionStatus",
    select: "dispositionStatus",
    width: "60px"
  },
  /*  adminDivision: {
     label: "行政区域:",
     type: 2,
     formV: "adminDivision",
     select: "adminDivision",
     width: "110px"
   }, */
  /*  trafficType: {
     label: "通行类型",
     type: 5,
     formV: "trafficType",
     select: "trafficType",
     width: "160px"
   }, */
  coId: {
    label: "企业名称:",
    type: 2,
    api: 'getCoId',
    formV: "CoId",
    select: "CoId",
    width: "200px"
  },
  coName: {
    label: "企业名称:",
    type: 6,
    formV: "coName",
    width: "160px"
  },
  personName: {
    label: "姓名:",
    type: 6,
    formV: "personName",
    width: "120px"
  },
  personCompany: {
    label: "申请人所属企业:",
    type: 6,
    formV: "personCompany",
    width: "120px"
  },
  coEin: {
    label: "企业税号:",
    type: 6,
    formV: "coEin",
    width: "160px"
  },
  coStatus: {
    label: "企业状态:",
    type: 2,
    formV: "coStatus",
    select: "coStatus",
    width: "80px"
  },
  /* selection: {
    type: 7,
    label: ""
  }, */
  /*  cardreadType: {
     type: 2,
     label: "读卡器类型:",
     formV: "cardreadType",
     select: "cardreadType",
     width: "120px"
   },
   warnlibrary: {
     type: 2,
     label: "告警库来源:",
     formV: "warnlibrary",
     select: "warnlibrary",
     width: "80px"
   }, */
  checkStatus: {
    label: "批审状态:",
    type: 2,
    formV: "checkStatus",
    select: "checkStatus",
    width: "130px"
  },
  personIdcard: {
    label: "身份证号:",
    type: 6,
    formV: "personIdcard",
    width: "130px"
  },
  personSex: {
    type: 2,
    label: "性别:",
    formV: "personSex",
    select: "personSex",
    width: "60px"
  },
  timeType: {
    type: 8,
    label: "时间类型:",
    formV: "timeType",
    select: "timeType",
    width: "120px"
  },
  timeType2: {
    type: 8,
    label: "时间类型:",
    formV: "timeType2",
    select: "timeType2",
    width: "120px"
  },
  deviceName: {
    label: "设备名称:",
    type: 6,
    formV: "deviceName",
    width: "120px"
  },
  deviceID: {
    label: "设备:",
    type: 2,
    api: '/dqi-hymanage/device/page',
    formV: "deviceID",
    select: "deviceID",
    width: "110px"
  },
  deviceType: {
    label: "设备类型:",
    type: 2,
    formV: "deviceType",
    select: "deviceType",
    width: "110px"
  },
  // carType: {
  //   label: "来访车辆类型:",
  //   type: 2,
  //   formV: "carType",
  //   select: "carType",
  //   width: "110px"
  // },
  passTime: {
    label: "通行时间:",
    type: 3,
    formV: "passTime"
  },
  coBusiness: {
    label: "经营范围:",
    type: 2,
    formV: "coBusiness",
    select: "coBusiness",
    width: "80px"
  },
  coType: {
    label: "企业类型:",
    type: 2,
    formV: "coType",
    select: "coType",
    width: "80px"
  },
  deviceStatus: {
    label: "设备状态:",
    type: 2,
    formV: "deviceStatus",
    select: "deviceStatus",
    width: "80px"
  },
  direction: {
    label: "方向:",
    type: 2,
    formV: "direction",
    select: "direction",
    width: "80px"
  },
  carFrom: {
    label: "来访车辆:",
    type: 2,
    formV: "carFrom",
    select: "carFrom",
    width: "80px"
  },
  frontRear: {
    label: "车头车尾:",
    type: 2,
    formV: "frontRear",
    select: "frontRear",
    width: "80px"
  },
  inOutFlag: {
    label: "出入口标识:",
    type: 2,
    formV: "inOutFlag",
    select: "inOutFlag",
    width: "80px"
  },
  source: {
    label: "申报来源:",
    type: 2,
    formV: "source",
    select: "source",
    width: "80px"
  },
  yesOrNo: {
    label: "是否:",
    type: 2,
    formV: "yesOrNo",
    select: "yesOrNo",
    width: "80px"
  },
  tollgateID: {
    label: "卡口:",
    type: 2,
    api: '/dqi-hymanage/tollgate/all',
    formV: "tollgateID",
    select: "tollgateID",
    width: "110px"
  },
  persontollgate:{
    label: "卡口:",
    type: 2,
    api: '/dqi-hymanage/tollgate/page',
    tollgatetype: 3,
    formV: "tollgateID",
    select: "tollgateID",
    width: "110px"
  },
  cartollgate:{
    label: "卡口:",
    type: 2,
    api: '/dqi-hymanage/tollgate/page',
    tollgatetype: 2,
    formV: "tollgateID",
    select: "tollgateID",
    width: "110px"
  },
  cameratollgate:{
    label: "卡口:",
    type: 2,
    api: '/dqi-hymanage/tollgate/page',
    tollgatetype: 1,
    formV: "tollgateID",
    select: "tollgateID",
    width: "110px"
  },
  tollgateType: {
    label: "卡口类型:",
    type: 2,
    formV: "tollgateType",
    select: "deviceType",
    width: "110px"
  },
  tollgateStatus: {
    label: "卡口状态:",
    type: 2,
    formV: "tollgateStatus",
    select: "deviceStatus",
    width: "80px"
  },
  tollgateName: {
    label: "卡口名称:",
    type: 6,
    formV: "tollgateName",
    width: "120px"
  },
  filename: {
    label: "资料名称:",
    type: 6,
    formV: "filename",
    width: "120px"
  },
  issuetime: {
    label: "发布时间:",
    type: 3,
    formV: "issuetime"
  },
  safetyTitle: {
    label: "标题:",
    type: 6,
    formV: "safetyTitle",
    width: "120px"
  },
  moduleCode: {
    label: "安全教育分类:",
    type: 2,
    formV: "moduleCode",
    select: "moduleCode",
    width: "100px"
  },
  passTime: {
    label: "通过时间:",
    type: 9,
    formV: "passTime"
  },
  tableName: {
    label: "日志日期:",
    type: 11,
    formV: "tableName"
  },
  logTime: {
    label: "查询时间:",
    type: 9,
    formV: "logTime"
  },
  creator:{
    label: "操作人:",
    type: 6,
    formV: "creator",
    width: "100px"
  }
};

//最终引用方法
export const getFormList = async function (ary) {
  let formlist = []; let selectoption = {};
  for (let item of ary) {
    formlist.push(allFormList[item])
  }
  // console.log('formlist',formlist,ary)
  selectoption = await getSelectoptions(formlist);
  // console.log('ddddd', formlist, selectoption)
  return { formlist, selectoption }
}


// WEBPACK FOOTER //
// ./src/components/form/carFormindex.js